import './global.css';
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from './routes';

function App() {


  return (
    <div className='container-main'>
    <BrowserRouter>
     <AllRoutes />
    </BrowserRouter>
    </div>
   
  );
}

export default App;
